import { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useParams } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import ModalOdontogramaLaboratorio from "./ModalOdontogramaLaboratorio";

function DetalleOrdenLaboratorio() {
    const { id } = useParams();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [orden, setOrden] = useState(null);
    const [loading, setLoading] = useState(false);

    // Modal agregar proceso
    const [showModalProceso, setShowModalProceso] = useState(false);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
    const [profesionales, setProfesionales] = useState([]);
    const [nuevoProceso, setNuevoProceso] = useState({
        profesional_id: '',
        fecha: new Date().toISOString().split('T')[0],
        hora: new Date().toTimeString().slice(0, 5),
        descripcion: '',
        estado: ''
    });

    // Modal ver odontograma
    const [showModalOdontograma, setShowModalOdontograma] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionLaboratorio');
        } else if (userdata.up && userdata.up.includes('gestionLaboratorio')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar profesionales - Usar endpoint optimizado que solo trae id, name, lastname
        axios.get('/usuarios-basico')
            .then(response => {
                if (response.status === 200) setProfesionales(response.data);
            })
            .catch(error => console.log('Error cargando profesionales: ' + error));

        // Cargar orden
        cargarOrden();
    }, [id]);

    const cargarOrden = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        axios.get(`/orden-laboratorio/${id}?uid=${userdata.user_id}`)
            .then(response => {
                if (response.status === 200) {
                    setOrden(response.data);
                }
            })
            .catch(error => {
                console.error('Error al cargar orden:', error);
                alert('Error al cargar la orden: ' + (error.response?.data?.message || error.message));
            });
    };

    const abrirModalProceso = (detalle) => {
        setDetalleSeleccionado(detalle);
        setNuevoProceso({
            profesional_id: '',
            fecha: new Date().toISOString().split('T')[0],
            hora: new Date().toTimeString().slice(0, 5),
            descripcion: '',
            estado: detalle.estado
        });
        setShowModalProceso(true);
    };

    const guardarProceso = async () => {
        if (!nuevoProceso.profesional_id || !nuevoProceso.descripcion || !nuevoProceso.estado) {
            alert('Por favor complete todos los campos requeridos');
            return;
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.post(
                `/detalle-laboratorio/${detalleSeleccionado.id}/proceso?uid=${userdata.user_id}`,
                nuevoProceso
            );

            if (response.status === 200 || response.status === 201) {
                alert('Proceso registrado exitosamente');
                setShowModalProceso(false);
                cargarOrden(); // Recargar la orden
            }
        } catch (error) {
            console.error('Error al guardar proceso:', error);
            alert('Error al guardar el proceso: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    const actualizarEstadoOrden = async (nuevoEstado) => {
        if (!window.confirm(`¿Está seguro de cambiar el estado de la orden a "${nuevoEstado}"?`)) {
            return;
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.put(
                `/orden-laboratorio/${id}?uid=${userdata.user_id}`,
                { estado: nuevoEstado }
            );

            if (response.status === 200) {
                alert('Estado actualizado exitosamente');
                cargarOrden();
            }
        } catch (error) {
            console.error('Error al actualizar estado:', error);
            alert('Error al actualizar el estado: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 'Pendiente': return 'badge-warning';
            case 'En Proceso': return 'badge-info';
            case 'Completada': return 'badge-primary';
            case 'Entregada': return 'badge-success';
            case 'Cancelada': return 'badge-danger';
            case 'Esterilización y Desinfección': return 'badge-secondary';
            case 'Toma de Impresiones y Modelado': return 'badge-info';
            case 'Fabricación de Dispositivos': return 'badge-primary';
            case 'Acabado y Pulido': return 'badge-warning';
            case 'Digitalización': return 'badge-info';
            case 'Entregado': return 'badge-success';
            case 'Corrección': return 'badge-danger';
            default: return 'badge-secondary';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        // Agregar 'T00:00:00' para evitar problemas de zona horaria
        const fechaLocal = new Date(fecha + 'T00:00:00');
        return fechaLocal.toLocaleDateString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || !orden) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="laboratory" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-laboratorio">Laboratorio</Link></li>
                                    <li className="breadcrumb-item"><Link to="/listado-ordenes-laboratorio">Órdenes</Link></li>
                                    <li className="breadcrumb-item">Detalle</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Orden {orden.numero_orden}</h1>
                            </div>
                            <div className="col-sm-4">
                                <Link to="/listado-ordenes-laboratorio" className="btn btn-secondary float-right">
                                    <i className="fas fa-arrow-left"></i> Volver
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Información General */}
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Información General</b></h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p><strong>Paciente:</strong> {orden.paciente_nombre}</p>
                                        <p><strong>Documento:</strong> {orden.paciente_documento}</p>
                                        <p><strong>Empresa:</strong> {orden.empresa_nombre || 'N/A'}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><strong>Fecha Recepción:</strong> {formatearFecha(orden.fecha_recepcion)}</p>
                                        <p><strong>Fecha Estimada Entrega:</strong> {formatearFecha(orden.fecha_estimada_entrega)} {orden.hora_estimada_entrega && `- ${orden.hora_estimada_entrega}`}</p>
                                        <p><strong>Usuario:</strong> {orden.usuario_nombre}</p>
                                        <p><strong>Estado:</strong> <span className={`badge ${getEstadoColor(orden.estado)}`}>{orden.estado}</span></p>
                                    </div>
                                </div>
                                {orden.observaciones && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p><strong>Observaciones:</strong> {orden.observaciones}</p>
                                        </div>
                                    </div>
                                )}




                                {orden.odontograma && (
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-info"
                                                onClick={() => setShowModalOdontograma(true)}
                                            >
                                                <i className="fas fa-tooth mr-2"></i> Ver Odontograma Adjunto
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Botones de cambio de estado */}
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <strong>Cambiar Estado:</strong>
                                        <div className="btn-group ml-2" role="group">
                                            {orden.estado !== 'En Proceso' && orden.estado !== 'Completada' && orden.estado !== 'Entregada' && orden.estado !== 'Cancelada' && (
                                                <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => actualizarEstadoOrden('En Proceso')}
                                                    disabled={loading}
                                                >
                                                    En Proceso
                                                </button>
                                            )}
                                            {orden.estado !== 'Completada' && orden.estado !== 'Entregada' && orden.estado !== 'Cancelada' && (
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => actualizarEstadoOrden('Completada')}
                                                    disabled={loading}
                                                >
                                                    Completada
                                                </button>
                                            )}
                                            {orden.estado !== 'Entregada' && orden.estado !== 'Cancelada' && (
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => actualizarEstadoOrden('Entregada')}
                                                    disabled={loading}
                                                >
                                                    Entregada
                                                </button>
                                            )}
                                            {orden.estado !== 'Cancelada' && orden.estado !== 'Entregada' && (
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => actualizarEstadoOrden('Cancelada')}
                                                    disabled={loading}
                                                >
                                                    Cancelar
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Trabajos */}
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Trabajos de la Orden</b></h5>
                            </div>
                            <div className="card-body">
                                {orden.detalles && orden.detalles.map((detalle, index) => (
                                    <div key={index} className="card mb-3">
                                        <div className="card-header bg-light">
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <h6 className="mb-0">
                                                        <strong>Trabajo #{index + 1}:</strong> {detalle.tipo_trabajo_nombre} - Diente {detalle.diente}
                                                    </h6>
                                                </div>
                                                <div className="col-md-4 text-right">
                                                    <span className={`badge ${getEstadoColor(detalle.estado)}`}>{detalle.estado}</span>
                                                    <button
                                                        className="btn btn-sm btn-primary ml-2"
                                                        onClick={() => abrirModalProceso(detalle)}
                                                    >
                                                        <i className="fas fa-plus"></i> Agregar Proceso
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                <div className="col-md-3"><strong>Material:</strong> {detalle.material_nombre}</div>
                                                <div className="col-md-3"><strong>Color:</strong> {detalle.color || 'N/A'}</div>
                                                <div className="col-md-6"><strong>Profesional:</strong> {detalle.profesional_nombre}</div>
                                            </div>
                                            {detalle.observaciones && (
                                                <div className="row mb-2">
                                                    <div className="col-md-12"><strong>Observaciones:</strong> {detalle.observaciones}</div>
                                                </div>
                                            )}

                                            {/* Procesos realizados */}
                                            {detalle.procesos && detalle.procesos.length > 0 && (
                                                <div className="mt-3">
                                                    <strong>Historial de Procesos:</strong>
                                                    <div className="table-responsive mt-2">
                                                        <table className="table table-sm table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Fecha</th>
                                                                    <th>Hora</th>
                                                                    <th>Profesional</th>
                                                                    <th>Estado</th>
                                                                    <th>Descripción</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {detalle.procesos.map((proceso, pIndex) => (
                                                                    <tr key={pIndex}>
                                                                        <td>{formatearFecha(proceso.fecha)}</td>
                                                                        <td>{proceso.hora}</td>
                                                                        <td>{proceso.profesional_nombre}</td>
                                                                        <td><span className={`badge ${getEstadoColor(proceso.estado)}`}>{proceso.estado}</span></td>
                                                                        <td>{proceso.descripcion}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </section>
            </div >

            {/* Modal Agregar Proceso */}
            {
                showModalProceso && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Agregar Proceso</h5>
                                    <button type="button" className="close" onClick={() => setShowModalProceso(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Profesional *</label>
                                                <select
                                                    className="form-control"
                                                    value={nuevoProceso.profesional_id}
                                                    onChange={(e) => setNuevoProceso({ ...nuevoProceso, profesional_id: e.target.value })}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {profesionales.map(prof => (
                                                        <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={nuevoProceso.fecha}
                                                    onChange={(e) => setNuevoProceso({ ...nuevoProceso, fecha: e.target.value })}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Hora *</label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={nuevoProceso.hora}
                                                    onChange={(e) => setNuevoProceso({ ...nuevoProceso, hora: e.target.value })}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Estado del Trabajo *</label>
                                                <select
                                                    className="form-control"
                                                    value={nuevoProceso.estado}
                                                    onChange={(e) => setNuevoProceso({ ...nuevoProceso, estado: e.target.value })}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    <option value="Esterilización y Desinfección">Esterilización y Desinfección</option>
                                                    <option value="Toma de Impresiones y Modelado">Toma de Impresiones y Modelado</option>
                                                    <option value="Fabricación de Dispositivos">Fabricación de Dispositivos</option>
                                                    <option value="Acabado y Pulido">Acabado y Pulido</option>
                                                    <option value="Digitalización">Digitalización</option>
                                                    <option value="Entregado">Entregado</option>
                                                    <option value="Corrección">Corrección</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Descripción del Proceso *</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={nuevoProceso.descripcion}
                                                    onChange={(e) => setNuevoProceso({ ...nuevoProceso, descripcion: e.target.value })}
                                                    placeholder="Describa el proceso realizado..."
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalProceso(false)}>
                                        Cancelar
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={guardarProceso} disabled={loading}>
                                        <i className="fas fa-save"></i> Guardar Proceso
                                        {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* Modal Ver Odontograma (Solo Lectura) */}
            {
                orden && orden.odontograma && (
                    <ModalOdontogramaLaboratorio
                        show={showModalOdontograma}
                        onHide={() => setShowModalOdontograma(false)}
                        initialData={orden.odontograma.datos}
                        readOnly={true}
                    />
                )
            }

            <Footer showToast={false} delay={0} />
        </div >
    );
}

export default DetalleOrdenLaboratorio;
